import type { FunctionComponent } from 'react'
import { TypographyV2 as Typography } from '@which/seatbelt'

import type { NewsletterData } from '../../../../pages/signup-complete/components/NewsletterSignups/newsletterData'
import { newsletterSfNameMap } from '../../../../pages/signup-complete/components/NewsletterSignups/newsletterData'
import { NewsletterLoggedInUserText } from '../NewsletterLoggedInUserText'
import type { SuccessData } from '../NewsletterSignUp.types'
import { RecommendationCard } from '../RecommendationCard/RecommendationCard'
import styles from './NewsletterSignUpThankYou.module.scss'

type Props = {
  successData: SuccessData
  newsletters: NewsletterData[]
  email?: string
  isUserAlreadySignedUp: boolean
}

export const NewsletterSignUpThankYou: FunctionComponent<Props> = ({
  successData,
  newsletters,
  email,
  isUserAlreadySignedUp,
}) => {
  const currentNewsletterName = newsletterSfNameMap.get(successData.source)?.name || ''

  return (
    <>
      <div className={styles.thankYouNotification}>
        <Typography tag="h2" textStyle="sb-text-heading-medium" className={styles.successTitle}>
          {email && isUserAlreadySignedUp
            ? `You've already signed up to our ${currentNewsletterName} newsletter`
            : 'Thank you'}
        </Typography>

        {email && isUserAlreadySignedUp ? (
          <NewsletterLoggedInUserText
            textStyle="sb-text-body-default-regular"
            className={styles.successDescription}
            email={email}
          ></NewsletterLoggedInUserText>
        ) : (
          <Typography
            textStyle="sb-text-body-default-regular"
            className={styles.successDescription}
          >
            You've successfully signed up to our {currentNewsletterName} newsletter
          </Typography>
        )}
      </div>
      {newsletters && newsletters.length > 0 && (
        <>
          <Typography tag="h3" textStyle="sb-text-heading-small" className={styles.youMightLike}>
            You might also like
          </Typography>
          <div className={styles.cardWrapper}>
            {newsletters.map(({ name, strapline, frequency, salesforceName }) => (
              <RecommendationCard
                key={name}
                form={successData}
                name={name}
                strapline={strapline}
                frequency={frequency}
                salesforceName={salesforceName}
              />
            ))}
          </div>
          <Typography
            className={styles.description}
            tag="p"
            textStyle="sb-text-interface-body-x-small-regular"
          >
            Our newsletters deliver free related content, along with other information about Which?
            Group products and services.
          </Typography>
        </>
      )}
    </>
  )
}
